module.exports = __webpack_public_path__ + "img/CASACCA FIOCCO PANTALONE MUSA.f2524956.jpg";